<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex>
        <card-carregando v-if="loading" />
        <v-card
          v-else
        >
          <v-toolbar
            dark
            color="primary"
          >
            <v-toolbar-title>{{ $route.meta.title }}</v-toolbar-title>
          </v-toolbar>
          <v-flex
            text-xs-center
            title
            indigo--text
            mt-5
            mb-3
            mx-4
          >
            INDICAÇÃO DE REPRESENTANTES PARA COMPOR O CONSELHO DE POLÍTICA CULTURAL
            <br>
            DADOS DO(A) INDICADO(A) PARA REPRESENTANTE {{ tabs == 'tab-titular' ? 'TITULAR' : 'SUPLENTE' }}
          </v-flex>
          <v-card-text>
            <v-card>
              <v-card-text>
                <v-tabs
                  v-model="tabs"
                  centered
                  icons-and-text
                >
                  <v-tab
                    href="#tab-titular"
                  >
                    Titular
                    <v-icon
                      center
                      class="text--lighten-2"
                    >
                      people
                    </v-icon>
                  </v-tab>
                  <v-tab
                    href="#tab-suplente"
                  >
                    Suplente
                    <v-icon
                      center
                      class="text--lighten-2"
                    >
                      people
                    </v-icon>
                  </v-tab>
                </v-tabs>
                <v-tabs-items
                  v-model="tabs"
                >
                  <v-tab-item
                    value="tab-titular"
                  >
                    <indicacao-organizacao-component 
                      :co-organizacao="organizacao.co_organizacao"
                      :indicado="titular"
                      tp-indicado="TITULAR"
                    />
                  </v-tab-item>
                  <v-tab-item
                    value="tab-suplente"
                  >
                    <indicacao-organizacao-component 
                      :co-organizacao="organizacao.co_organizacao"
                      :indicado="suplente"                    
                      tp-indicado="SUPLENTE"
                    />
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import CardCarregando from '@/modules/shared/components/CardCarregando';
import IndicacaoOrganizacaoComponent from './components/IndicacaoOrganizacaoComponent';
import codigosFase from '../../fase/utils/codigosFase';
import organizacaoUtils from '../utils/organizacaoUtils';

export default {
  name: 'IndicacaoOrganizacao',

  components: {
    CardCarregando,
    IndicacaoOrganizacaoComponent,
  },

  data() {
    return {
      codigosFase,
      organizacaoUtils,
      titular: {},
      suplente: {},
      loading: true,
      usuarioLogado: {},
      tabs: 'tab-titular',

    };
  },

  watch: {
    fases() {
      this.checkIndicacaoEditavel();
    },
    usuario(valor) {
      this.usuarioLogado = valor;
    },
    usuarioLogado(usuario) {
      if (this.checkUsuario()) {
        this.obterDadosOrganizacao(usuario.co_organizacao);
      }
    },
    organizacao(organizacao) {
      this.obterDadosHabilitacaoOrganizacao(organizacao.co_organizacao);
      this.obterIndicadosPorOrganizacao(organizacao.co_organizacao);
    },
    habilitacaoOrganizacao() {
      this.checkOrganizacaoHabilitada();
    },
    indicadosOrganizacao(indicados){
      if(indicados){
        this.titular = indicados.find(a=> a.tp_indicado === 'TITULAR');
        this.suplente = indicados.find(a=> a.tp_indicado === 'SUPLENTE');
      }
      this.loading = false;
    }
  },

  computed: {
    ...mapGetters({
      perfil: 'conta/perfil',
      usuario: 'conta/usuario',

      fases: 'fase/fases',

      organizacao: 'organizacao/organizacao',
      habilitacaoOrganizacao: 'organizacao/habilitacaoOrganizacao',
      indicadosOrganizacao: 'organizacao/indicadosOrganizacao',

    }),
  },

  methods: {
    ...mapActions({
      definirMensagemSucesso: 'app/setMensagemSucesso',
      definirMensagemErro: 'app/setMensagemErro',

      obterUsuarioLogado: 'conta/tratarUsuarioLogado',

      obterFases: 'fase/obterFases',

      obterDadosOrganizacao: 'organizacao/obterDadosOrganizacao',
      obterDadosHabilitacaoOrganizacao: 'organizacao/obterDadosHabilitacaoOrganizacao',
      obterIndicadosPorOrganizacao: 'organizacao/obterIndicadosPorOrganizacao'
    }),
    checkIndicacaoEditavel() {
      if (!this.iniciadoPeriodoIndicacao()) {
        this.definirMensagemErro('Indicação de Titulares e Suplentes Indisponível!');
        this.$router.push('/').catch(()=>{});
      }
    },
    checkUsuario() {
      if (this.perfil.no_perfil != 'organizacao') {
        this.definirMensagemErro('Organização ou Entidade Cultural não associada ao perfil');
        this.$router.push('/').catch(()=>{});
        return false;
      }
      return true;
    },
    checkOrganizacaoHabilitada() {
      if (!this.habilitacaoOrganizacao.st_habilitacao == organizacaoUtils.HABILITADA_CLASSIFICADA) {
        this.definirMensagemErro('Organização ou Entidade Cultural não habilitada para fase de Indicação');
        this.$router.push('/').catch(()=>{});
      }
    },
    iniciadoPeriodoIndicacao() {
      let faseIndicacaoOrganizacao = {};
      faseIndicacaoOrganizacao = this.fases.find(f => f.tp_fase == codigosFase.TP_INDICACAO_ORGANIZACAO);
      const dataInicio = moment(faseIndicacaoOrganizacao.dh_inicio).toDate().getTime();
      const dataAtual = moment().toDate().getTime();

      return dataAtual >= dataInicio;
    },
    	},
  mounted() {
    if (this.fases && this.fases.length > 0) {
      this.checkIndicacaoEditavel();
    }
    this.obterUsuarioLogado();

    this.usuarioLogado = this.usuario;
  },
};
</script>
